import { FC, PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";
import { Loading } from "@/components/Loading";
import { useRootLayout } from "@/routes/layouts/RootLayout/RootLayout.hooks";

export const RootLayout: FC<PropsWithChildren> = () => {
  const { initialized } = useRootLayout();

  if (!initialized) {
    return <Loading />;
  }
  return <Outlet />;
};
